import { Platform, StyleSheet } from 'react-native';

import { ArrowRightIcon } from '@pletly/ui';
import { getName } from '@pletly/shared';
import { PostSelectedUsersInfo } from '%screens/posts/review/components/PostSelectedUsersInfo';
import { User } from '%__generated__/types';
import { UserAvatar } from '%components/UserAvatar';

const ARROW_SIZE = Platform.OS === 'web' ? 24 : 16;

interface Props {
	users: User[];
}

export const PostCareRecipients = ({ users }: Props) => {
	if (users?.length === 0) {
		return null;
	}

	const [user] = users;

	return (
		<>
			<ArrowRightIcon height={ARROW_SIZE} width={ARROW_SIZE} />

			<UserAvatar
				size={Platform.OS === 'web' ? 24 : 16}
				src={user.profilePhoto?.url}
				style={styles.firstAvatar}
				username={getName(user)}
			/>
			<PostSelectedUsersInfo users={users} />
		</>
	);
};

const styles = StyleSheet.create({
	firstAvatar: {
		minWidth: 16,
		...Platform.select({
			web: { marginRight: -8 },
		}),
	},
});
